/** Value of `modal_id` for the Gator Protect Free threats entry in `GET /api/v3/modals`. */
export const PORTAL_MODAL_SITE_WITHOUT_PROTECTION_ID = 'site-without-protection';

export const PORTAL_MODAL_FEATURE_GATOR_PROTECT = 'gator-protect';
